<template>
    <div>
        <ckeditor :editor="editor" v-model="editorValue" :disabled="disabled" :config="editorConfig"></ckeditor>
    </div>
</template>

<script>
    import InlineEditor from 'ckeditor5-build-inline-with-base64-image-upload'
    export default {
        name: 'InlineEditor',
        props: {
            value: {
                type: String
            },
            disabled:{type:Boolean,default:false}
        },
        data() {
            return {
                editor: InlineEditor,
                editorConfig: {}
            };
        },
        computed: {
            editorValue: {
                get() {
                    return this.value
                },
                set(val){
                    this.$emit('input', val)
                }
            }

        }
    }
</script>